import { Tooltip } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/primary-trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { DeletePassageProps } from './DeletePassage.types';
import * as Styled from './DeletePassage.styles';

export const DeletePassage = ({
  passage,
  isDisabled,
  disabledReason,
  isModalOpen,
  onModalOpen,
  onModalClose,
  isLoading,
  onSubmit,
}: DeletePassageProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Tooltip title={isDisabled && disabledReason ? disabledReason : ''}>
        <Styled.ActionWrapper>
          <Styled.DeleteButton
            data-testid={`delete-passage-${passage.id}`}
            aria-label={formatMessage({ id: AppMessages['definitions.passages.delete.title'] })}
            disabled={isDisabled}
            onClick={onModalOpen}
          >
            <TrashIcon />
          </Styled.DeleteButton>
        </Styled.ActionWrapper>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['definitions.passages.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonDisabled={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages['definitions.passages.delete.subtitle'] })}
          </ActionModal.Subtitle>
          <ActionModal.Text>{formatMessage({ id: AppMessages['definitions.passages.delete.text'] })}</ActionModal.Text>
          <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
        </>
      </ActionModal>
    </>
  );
};
